module.exports = __webpack_public_path__ + "img/icon_tourism_out.62aae586.png";